import { createContext } from "react";

// SSR needs a different API url from CSR (which uses
// PUBLIC_SOFA_BACKEND_URL) and we don't want to expose the SSR url to the
// client. So, instead we provide it via context rendered in entry.server.tsx
export const APIUrlContext = createContext<string>("");
